/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './record-search.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../json-editor-wrapper/json-editor-wrapper.component.ngfactory';
import * as i3 from '../../../../app/record-editor/json-editor-wrapper/json-editor-wrapper.component';
import * as i4 from '@angular/router';
import * as i5 from '../../../../app/core/services/record-api.service';
import * as i6 from '../../../../app/core/services/app-config.service';
import * as i7 from 'ngx-toastr';
import * as i8 from '../../../../app/core/services/dom-utils.service';
import * as i9 from '../../../../app/core/services/global-app-state.service';
import * as i10 from '@angular/common';
import * as i11 from '../../../../app/record-editor/record-search/record-search.component';
import * as i12 from '../../../../app/core/services/record-search.service';
const styles_RecordSearchComponent:any[] = [i0.styles];
export const RenderType_RecordSearchComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_RecordSearchComponent,data:{}});
function View_RecordSearchComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'re-json-editor-wrapper',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_JsonEditorWrapperComponent_0,
      i2.RenderType_JsonEditorWrapperComponent)),i1.ɵdid(1,770048,(null as any),0,
      i3.JsonEditorWrapperComponent,[i1.ChangeDetectorRef,i4.ActivatedRoute,i5.RecordApiService,
          i6.AppConfigService,i7.ToastrService,i8.DomUtilsService,i9.GlobalAppStateService],
      {recordId:[0,'recordId'],recordType:[1,'recordType']},(null as any)),(_l()(),
      i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.foundRecordIds[_co.recordCursor];
    const currVal_1:any = _co.recordType;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_RecordSearchComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_RecordSearchComponent_1)),i1.ɵdid(1,16384,(null as any),0,i10.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i11.RecordSearchComponent = _v.component;
    const currVal_0:any = ((_co.recordType && _co.foundRecordIds) && (_co.recordCursor >= 0));
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_RecordSearchComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-record-search',
      ([] as any[]),(null as any),(null as any),(null as any),View_RecordSearchComponent_0,
      RenderType_RecordSearchComponent)),i1.ɵdid(1,245760,(null as any),0,i11.RecordSearchComponent,
      [i4.ActivatedRoute,i1.ChangeDetectorRef,i12.RecordSearchService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const RecordSearchComponentNgFactory:i1.ComponentFactory<i11.RecordSearchComponent> = i1.ɵccf('re-record-search',
    i11.RecordSearchComponent,View_RecordSearchComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3JlY29yZC1lZGl0b3IvcmVjb3JkLXNlYXJjaC9yZWNvcmQtc2VhcmNoLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9yZWNvcmQtZWRpdG9yL3JlY29yZC1zZWFyY2gvcmVjb3JkLXNlYXJjaC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9yZWNvcmQtZWRpdG9yL3JlY29yZC1zZWFyY2gvcmVjb3JkLXNlYXJjaC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3JlY29yZC1lZGl0b3IvcmVjb3JkLXNlYXJjaC9yZWNvcmQtc2VhcmNoLmNvbXBvbmVudC50cy5SZWNvcmRTZWFyY2hDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cmUtanNvbi1lZGl0b3Itd3JhcHBlciAqbmdJZj1cInJlY29yZFR5cGUgJiYgZm91bmRSZWNvcmRJZHMgJiYgcmVjb3JkQ3Vyc29yID49IDBcIlxuICBbcmVjb3JkVHlwZV09XCJyZWNvcmRUeXBlXCIgW3JlY29yZElkXT1cImZvdW5kUmVjb3JkSWRzW3JlY29yZEN1cnNvcl1cIj5cbjwvcmUtanNvbi1lZGl0b3Itd3JhcHBlcj5cbiIsIjxyZS1yZWNvcmQtc2VhcmNoPjwvcmUtcmVjb3JkLXNlYXJjaD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7OENBQUEsVUFBQTtvQ0FBQTswRkFBQTtNQUFBLHFFQUNzRTthQUFBOztJQUExQztJQUExQjtJQURGLFdBQzRCLFVBQTFCLFNBREY7Ozs7b0JBQUE7TUFBQSxzQ0FBQTtvQkFBQSxtQ0FFeUI7TUFBQTs7SUFGRDtJQUF4QixXQUF3QixTQUF4Qjs7OztvQkNBQTtNQUFBO3NDQUFBLFVBQUE7TUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/record-editor/record-search/record-search.component.ngfactory.ts